import { Box } from "@mui/material";
import { styled as muiStyled } from '@mui/material/styles';
import zIndex from "@mui/material/styles/zIndex";
import { borderRadius, borderRight, fontSize, fontWeight } from "@mui/system";
import { thirdly2 } from "styles/theme";
import { gray } from "styles/theme";
import { thirdly } from "styles/theme";
import { error } from "styles/theme";
import { secondary } from "styles/theme";

export const PerformAssessmentAgainStyles = muiStyled(Box)(({ size = "medium", fill, stroke, theme, $systemUI }) => ({

}));

export const TooltipMessageStyles = muiStyled(Box)(({ }) => ({
    position: 'absolute',
    bottom: 48,
    right: 30,
    '.MuiSpeedDial-root': {
        alignItems: "end"
    },
    '.MuiButtonBase-root.MuiFab-root.MuiSpeedDial-fab': {
        background: thirdly,
        position: "relative",
        right: 5
    },
    '.MuiButtonBase-root.MuiFab-root.MuiSpeedDialAction-fab': {
        background: "white",
        padding: 20,
        borderRadius: 10,
        fontSize: 17,
        width: 400,
        height: 100,
        zIndex: 11,
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
    },
    '.tooltip-corner': {
        background: "white",
        right: 49,
        width: 20,
        height: 20,
        position: "absolute",
        top: 89,
        borderLeft: "1px solid #efefef",
        borderBottom: "1px solid #efefef",
        transform: "rotate(45deg)",
    },
}));

export const PerformAssessmentStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    height: "100%",
    background: "white",
    borderRadius: 15,
    '.wrap-waves-and-button': {
        display: "flex",
        columnGap: 10,
        alignItems: "center"
    },
    '.waves': {
        border: "1px solid rgb(202, 211, 223)"
    },
    'canvas': {
        borderRadius: 35,
    },
    '.tooltip-fab': {
        position: "absolute",
        bottom: 53,
        right: 40
    },
    '.tooltip-corner': {
        background: "white",
        width: 20,
        height: 20,
        position: "absolute",
        top: 79,
        transform: "rotate(45deg)",
        borderBottom: "1px solid #e6e6e6",
        borderLeft: "1px solid #e6e6e6",
    },
    '.description-tooltip': {
        position: "absolute",
        top: 15,
        right: 15,
        background: "white",
        padding: 20,
        borderRadius: 10,
        fontSize: 19,
        width: 300,
        height: 50,
        zIndex: 11,
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
        boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)"
    },
    '.perform-assessment-header': {
        position: "absolute"
    },
    '.wrap-assessment-details': {
        padding: "0px 15px",
        color: "rgb(202, 211, 223)",
        '.chip': {
            color: "rgb(202, 211, 223)",
            borderColor: "rgb(202, 211, 223)"
        }
    },
    '.wrap-play-pause': {
        padding: "15px 0px 15px 65px",
        height: 30,
        '.MuiButtonBase-root': {
            background: "white !important",
            border: `1px solid rgb(202, 211, 223)`,
            color: "rgb(202, 211, 223)"
        }
    },
    '.fab-button': {
        '.MuiButtonBase-root.MuiIconButton-root': {
            position: "absolute",
            bottom: 70,
            right: 70
        }
    },
    '.play-pause-cartoon': {
        transform: "translateZ(0px)",
        flexShrink: 0,
        zIndex: 10,
        '.MuiButtonBase-root.MuiIconButton-root': {
            position: "absolute",
            bottom: 223,
            right: 371,
            background: thirdly2
        }
    },
    '.start-end-img': {
        width: 200,
        height: 200,
        cursor: "pointer",
        ':hover': {
            opacity: 0.8
        }
    }
}));

const fabButtonSize = {
    "large": {
        button: {
            width: 130,
            height: 130
        },
        icon: {
            width: 70,
            height: 70
        }
    },
    "medium": {
        button: {
            width: 100,
            height: 100
        },
        icon: {
            width: 50,
            height: 50
        }
    }
}

export const FabButtonStyles = muiStyled(Box)(({ size = "medium", fill, stroke, theme, $systemUI }) => ({
    '.MuiButtonBase-root.MuiIconButton-root': {
        ...fabButtonSize[size]?.button,
        background: secondary,
        'path': {
            stroke: stroke,
            fill: fill || "white"
        },
        'svg': {
            ...fabButtonSize[size]?.icon
        }
    }
}));

export const CheckPermissionStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    '.wrap-fab-button': {
        top: 130,
        left: 100,
        position: "relative"
    },
    '.check-permissions-img': {
        width: 600,
        height: 700
    },
    '.refresh-check-permissions-img': {
        display: "flex",
        alignItems: "center"
    },
    '.wrap-cartoon-and-button': {
        display: "flex",
        columnGap: 10
    }
}));


export const Step1Styles = muiStyled(Box)(({ pathHeight, pathWidth, cartoonMarginRight, theme, $systemUI }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    '.wrap-sun': {
        // marginLeft: 100
    },
    '.wrap-fab-button': {
        top: 180,
        left: 160,
        position: "relative",
        [theme.breakpoints.down('md')]: {
            left: -100
        },
    },
    '.play-pause-cartoon .MuiButtonBase-root.MuiIconButton-root': {
        right: "222px !important",
        bottom: "200px !important"
    },
    '.path-img': {
        width: pathWidth || 1700,
        height: pathHeight || 200,
        position: "absolute",
        bottom: 70,
    },
    '.sun': {
        width: 500,
        height: 380,
        position: "absolute",
        top: 10,
        left: 450,
        zIndex: 1
    },
    '.cartoon-img': {
        width: 420,
        height: 420,
        position: "absolute",
        bottom: 40
    },
    '.wrap-cartoon-img': {
        marginRight: cartoonMarginRight
    },
    '.butterfly1': {
        width: 35,
        height: 35,
        position: "absolute",
        right: 300,
        top: 330
    },
    '.butterfly2': {
        width: 25,
        height: 25,
        position: "absolute",
        top: 150
    },
    '.butterfly3': {
        width: 30,
        height: 30,
        position: "absolute",
        top: 200,
        left: 500
    },
}));

export const Step2Styles = muiStyled(Box)(({ theme, $systemUI }) => ({
    display: "flex",
    height: "100%",
    justifyContent: "center",
    '.wrap-cartoon-img': {
        position: "absolute",
        top: 37,
        right: -80,
    },
    '.cartoon-img': {
        width: 500,
        height: 500,
        // position: "absolute",
    },
    '.wrap-content-with-cartoon': {
        display: "flex",
        alignItems: "center",
        width: "100%"
    },
    '.wrap-word-and-arrow': {
        display: "flex",
        width: "100%",
        justifyContent: "space-around",
        alignItems: "center"
    },
    '.side': {
        transform: 'translateZ(0px)',
        flexShrink: 0,
        zIndex: 3
    },
    '.next-button': {
        position: "absolute",
        // bottom: 10
    },
    '.play-pause-cartoon': {
        '.MuiButtonBase-root.MuiIconButton-root': {
            bottom: 193,
            right: 171,
        }
    }
}));

export const Step3Styles = muiStyled(Box)(({ theme, $systemUI }) => ({
    display: "flex",
    alignItems: "center",
    height: "100%",
    justifyContent: "center",
    '.wrap-fab-button': {
        top: 130,
        left: 100,
        position: "relative",
        [theme.breakpoints.down('md')]: {
            left: -100
        },
    },
    '.wrap-cartoon-img': {
        // transform: 'translateZ(0px)',
        // flexShrink: 0,
        // zIndex: 3,
        // width: 0,
        // height: 800
    },
    '.cartoon-img': {
        width: 700,
        height: 700,
        // position: "absolute",
    },
    '.wrap-content': {
        display: "flex",
        alignItems: "center"
    },
    '.mic-img': {
        width: 100,
        height: 100
    }
}));

export const Step4Styles = muiStyled(Box)(({ theme, $systemUI }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
}));

export const Step5Styles = muiStyled(Box)(({ theme, $systemUI }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    '.finish-perform-img': {
        width: 500,
        height: 500
    }
}));

export const Step6Styles = muiStyled(Box)(({ theme, $systemUI }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",

}));